import { useEffect, useState } from "react";
import { CloseGreyIcon } from "../../../assets/icons";
import { useNotification } from "../../toster-notification/NotificationContext";
import { TagType } from "../../../models/base/TagType";
import { tagService } from "../../../services/tagService";
import { nameToSlug } from "../../../utils/slugService";
import Loader from "../../shared/Loader";
import { Switch } from "@mui/material";

interface EditTagViewProps {
    id: string;
    onClose: () => void;
}

export function EditTagView({ id, onClose }: EditTagViewProps) {
    const [name, setName] = useState<string>('');
    const [nameError, setNameError] = useState<string>('');
    const [slug, setSlug] = useState<string>('');
    const [slugError, setSlugError] = useState<string>('');
    const [tagType, setTagType] = useState<TagType>(TagType.FoodCategory);
    const [tagTypeError, setTagTypeError] = useState<string>('');
    const [isActive, setIsActive] = useState<boolean>(false);

    const [loading, setLoading] = useState<boolean>(false);
    const { notify } = useNotification();


    useEffect(() => {
        fetchTagDetails();
    }, [id]);
    

    const fetchTagDetails = async () => {
        setLoading(true);
        try{
            const reponse = await tagService.getById(id);

            if(reponse.success && reponse.data){
                setName(reponse.data.name);
                setSlug(reponse.data.slug);
                setTagType(reponse.data.type);
                setIsActive(reponse.data.isActive);
            } else {
                notify('error', 'Greška prilikom učitavanja taga.');
            }
        }catch(error){
            notify('error', 'Greška prilikom učitavanja taga.');
        } finally {
            setLoading(false);
        }
    }

    const handleUpdateTag = async () => {
        // Validate inputs
        setNameError('');
        setSlugError('');
        setTagTypeError('');

        let isValid = true;

        if (!name.trim()) {
            setNameError('Naziv je obavezan.');
            isValid = false;
        }

        if (!slug.trim()) {
            setSlugError('Slug je obavezan.');
            isValid = false;
        }

        if (!tagType || tagType === null) {
            setTagTypeError('Tip taga je obavezan.');
            isValid = false;
        }

        if (!isValid) {
            return;
        }

        setLoading(true);
        try {
            const response = await tagService.update(id, { name, slug, type: Number(tagType) as TagType, isActive });

            if (response.success) {
                notify('success', 'Tag je uspešno ažuriran.');
                onClose();
            } else {
                notify('error', 'Greška prilikom ažuriranja taga.');
            }
        } catch (error) {
            notify('error', 'Greška prilikom ažuriranja taga.');
        } finally {
            setLoading(false);
        }
    };


    if (loading) {
        return <Loader />
    }

    return (
        <section className="modal-section">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">Izmeni Tag</div>
                                <div className="description-text">Unesite detalje o tagu</div>
                            </div>
                            <div className="modal-button-div">
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" onClick={onClose} />
                            </div>
                        </div>
                        <div className="modal-form-block w-form">
                            <form className="modal-form">
                                <div className="modal-form-div">
                                    <label className="modal-form-label">Naziv *</label>
                                    <input className="form-input grey w-input" placeholder="Unesite naziv taga" type="text"
                                        value={name}
                                        onChange={(e) => {
                                            setName(e.target.value)
                                            setSlug(nameToSlug(e.target.value))
                                        }}
                                    />
                                    <div className="text-error">{nameError}</div>
                                </div>
                                <div className="modal-form-div">
                                    <label className="modal-form-label">Slug *</label>
                                    <input className="form-input grey w-input" placeholder="Unesite slug" type="text"
                                        value={slug}
                                        onChange={(e) => setSlug(e.target.value)}
                                    />
                                    <div className="text-error">{slugError}</div>
                                </div>
                                <div className="modal-form-div">
                                    <label className="modal-form-label">Tip *</label>
                                    <select className="form-select strech w-select"
                                        value={tagType}
                                        onChange={(e) => setTagType(Number(e.target.value) as TagType)}
                                    >
                                        <option value={TagType.LocalType}>Tip lokala</option>
                                        <option value={TagType.Feature}>Feature</option>
                                        <option value={TagType.Ambience}>Ambijent</option>
                                        <option value={TagType.FoodCategory}>Kategorija-tip hrane</option>
                                    </select>
                                    <div className="text-error">{tagTypeError}</div>
                                </div>

                                <div className="modal-form-div f-horizontal">
                                    <label className="modal-form-label">Aktivna notifikacija*</label>
                                    <Switch
                                        checked={isActive}
                                        onChange={(e) => setIsActive(e.target.checked)}
                                    />
                                </div>
                            </form>
                        </div>
                        <div className="modal-buttons">
                            <div className="button-secondary medium" onClick={onClose}>
                                <div>Otkaži</div>
                            </div>
                            <div className="button-primary medium" onClick={handleUpdateTag}>
                                <div>Ažuriraj tag</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
}